import { Pipe, PipeTransform } from '@angular/core';

const COLORS = [
  '#00b2dd',
  '#ec008c',
  '#a23f97',
  '#f58220',
  '#ffdd00',
  '#69be2b',
  '#004b35',
  '#00a657',
  '#bfd857',
  '#00b5db',
  '#d0021b',
];
@Pipe({ name: 'getColor' })
export class GetInitialColorPipe implements PipeTransform {
  transform(index: number): string {
    return COLORS[index % COLORS.length];
  }
}
